var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1826_849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17C14.5 18.65 13.15 20 11.5 20C9.85 20 8.5 18.65 8.5 17H10.5C10.5 17.55 10.95 18 11.5 18C12.05 18 12.5 17.55 12.5 17C12.5 16.45 12.05 16 11.5 16H2V14H11.5C13.15 14 14.5 15.35 14.5 17ZM19 6.5C19 4.57 17.43 3 15.5 3C13.57 3 12 4.57 12 6.5H14C14 5.67 14.67 5 15.5 5C16.33 5 17 5.67 17 6.5C17 7.33 16.33 8 15.5 8H2V10H15.5C17.43 10 19 8.43 19 6.5ZM18.5 11H2V13H18.5C19.33 13 20 13.67 20 14.5C20 15.33 19.33 16 18.5 16V18C20.43 18 22 16.43 22 14.5C22 12.57 20.43 11 18.5 11Z",
    fill: "#3287EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1826_849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.d4e2f041514dbc4b9518b28ac2c1b5e1.svg";
export { ForwardRef as ReactComponent };